export default "__VITE_ASSET__73e61029__"